import React, { useState } from 'react';

interface APIMethod {
  method: string;
  description: string;
  active: boolean;
}

interface API {
  id: number;
  name: string;
  description: string;
  methods: APIMethod[];
}

const ActiveAPIs: React.FC = () => {
  const [apis, setApis] = useState<API[]>([
    {
      id: 1,
      name: "User Management API",
      description: "Handles user creation, deletion, and updates.",
      methods: [
        { method: "GET", description: "Fetches all users.", active: true },
        { method: "POST", description: "Creates a new user.", active: false },
        { method: "PUT", description: "Updates an existing user.", active: true },
        { method: "DELETE", description: "Deletes a user.", active: false }
      ]
    },
    {
      id: 2,
      name: "Product API",
      description: "Manages product inventory.",
      methods: [
        { method: "GET", description: "Gets list of all products.", active: true },
        { method: "POST", description: "Adds a new product to the inventory.", active: true }
      ]
    }
  ]);

  const toggleMethodActive = (apiId: number, methodName: string) => {
    setApis(apis.map(api => {
      if (api.id === apiId) {
        return {
          ...api,
          methods: api.methods.map(method => {
            if (method.method === methodName) {
              return { ...method, active: !method.active };
            }
            return method;
          })
        };
      }
      return api;
    }));
  };

  return (
    <div style={styles.container}>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>API Name / Description</th>
            <th style={styles.th}>Methods</th>
          </tr>
        </thead>
        <tbody>
          {apis.map(api => (
            <tr key={api.id} style={styles.tr}>
              <td style={styles.td}>
                <strong>{api.name}</strong> - {api.description}
              </td>
              <td style={styles.td}>
                {api.methods.map((method, index) => (
                  <div key={index} style={styles.method}>
                    <strong>{method.method}:</strong> {method.description}
                    <label style={styles.toggleLabel}>
                      <input
                        type="checkbox"
                        checked={method.active}
                        onChange={() => toggleMethodActive(api.id, method.method)}
                        style={styles.toggleInput}
                      />
                      {method.active ? ' Active' : ' Inactive'}
                    </label>
                  </div>
                ))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
const styles: { [key: string]: React.CSSProperties } = {
    container: {
        padding: '20px'
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse', // Correct type is now explicitly set
    },
    th: {
        backgroundColor: '#f0f0f0',
        padding: '10px 15px',
        textAlign: 'left',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    tr: {
        backgroundColor: '#fff',
    },
    td: {
        padding: '10px 15px',
    },
    method: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: '5px 0',
        backgroundColor: '#eef',
        padding: '5px 10px',
        borderRadius: '5px',
    },
    toggleLabel: {
        marginLeft: '10px',
        cursor: 'pointer',
    },
    toggleInput: {
        marginRight: '5px',
    },
};


export default ActiveAPIs;
